import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { CONTACT } from 'config/contact';

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Privacy Policy | Make Mind Automations</title>
        <meta
          name="description"
          content="How Make Mind Automations collects, uses, and protects your information when you use this website."
        />
        <link rel="canonical" href="https://makemindautomations.tech/privacy" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        <main className="py-20">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-4xl font-bold text-text-primary mb-4">Privacy Policy</h1>
            <p className="text-text-secondary mb-10">Last updated: October 24, 2026</p>

            <div className="space-y-10 text-text-secondary leading-relaxed">
              <section>
                <h2 className="text-2xl font-bold text-text-primary mb-3">What we collect</h2>
                <p>
                  When you use our contact form, we collect the details you submit: your name, email
                  address, phone number, company, and anything you write about your project. When you
                  subscribe to our newsletter, we collect your name and email address. We also collect
                  basic, anonymized usage data through analytics so we can see which pages people find
                  useful.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-text-primary mb-3">How we use it</h2>
                <p>
                  We use your details only to reply to your enquiry, deliver the service you asked
                  about, and send the newsletter you subscribed to. We do not sell your personal data,
                  and we do not share it with third parties for their marketing.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-text-primary mb-3">Where it is stored</h2>
                <p>
                  Form submissions and newsletter subscriptions are stored in our Supabase database,
                  and notification emails are sent through our email provider. Access is limited to
                  our team members who need it to respond to you.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-text-primary mb-3">Cookies</h2>
                <p>
                  This site uses essential cookies to remember your theme preference, and analytics
                  cookies to understand aggregate usage. You can block or delete cookies in your
                  browser settings; the site will still work. See our Cookie Policy for details.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-text-primary mb-3">Your choices</h2>
                <p>
                  You can unsubscribe from our newsletter at any time using the link in any email.
                  You can ask us to correct or delete your personal data by contacting us at the
                  email below, and we will respond within a reasonable time.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-text-primary mb-3">Contact us</h2>
                <p>
                  For any privacy question, email us at{' '}
                  <a className="text-primary" href={`mailto:${CONTACT.email}`}>
                    {CONTACT.email}
                  </a>
                  . Make Mind Automations and Digital Marketing Agency is based in Najibabad, Uttar Pradesh, India.
                </p>
              </section>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default PrivacyPolicy;
